module.exports = "/static/assets/b2935b0787ff373cc04c7d2c92de9adb.gif";